package com.volkswagen.vocs.grip.vocstis

import kotlin.String
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
public enum class TariffRegion {
  @SerialName(value = "BE")
  Be,
  @SerialName(value = "BR")
  Br,
  @SerialName(value = "DE")
  De,
  @SerialName(value = "ES")
  Es,
  @SerialName(value = "GB")
  Gb,
  @SerialName(value = "HU")
  Hu,
  @SerialName(value = "MY")
  My,
  @SerialName(value = "PL")
  Pl,
  @SerialName(value = "PT")
  Pt,
  @SerialName(value = "SK")
  Sk,
  ;

  override fun toString(): String = serializer().descriptor.getElementName(ordinal)
}
